import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, ApiError } from '../lib/api';
import { useAuth } from '../auth/AuthContext';

export function ChangePasswordPage() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    if (next !== confirm) {
      setError('New passwords do not match.');
      return;
    }
    if (next.length < 12) {
      setError('New password must be at least 12 characters.');
      return;
    }
    setSubmitting(true);
    try {
      await api.changePassword(current, next);
      await refresh();
      navigate('/dashboard', { replace: true });
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Could not change password.');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="login">
      <div className="login__panel">
        <div className="login__brand">
          <img src="/design-system/assets/VIN-light.svg" alt="VIN" />
          <span className="login__brand-tag">AI Software Registry</span>
        </div>
        <div className="login__hello">First sign-in</div>
        <h1 className="login__headline">Set a new password.</h1>
        <p className="login__lede">
          The temporary password from the boot log lets you in once. Pick a strong replacement
          (12+ characters) and you're set.
        </p>
      </div>

      <div className="login__form-side">
        <div className="login__card">
          <h2 className="login__title">Change password</h2>
          <form className="login__fields" onSubmit={(e) => void onSubmit(e)}>
            <div className="field">
              <label className="field__label" htmlFor="current">Current password</label>
              <input
                id="current"
                type="password"
                value={current}
                autoComplete="current-password"
                onChange={(e) => setCurrent(e.target.value)}
                required
              />
            </div>
            <div className="field">
              <label className="field__label" htmlFor="next">New password</label>
              <input
                id="next"
                type="password"
                value={next}
                autoComplete="new-password"
                onChange={(e) => setNext(e.target.value)}
                required
                minLength={12}
              />
              <p className="field__help">Minimum 12 characters.</p>
            </div>
            <div className="field">
              <label className="field__label" htmlFor="confirm">Confirm new password</label>
              <input
                id="confirm"
                type="password"
                value={confirm}
                autoComplete="new-password"
                onChange={(e) => setConfirm(e.target.value)}
                required
              />
            </div>
            {error && <div className="field__error">{error}</div>}
            <button className="btn btn--primary btn--block btn--lg" type="submit" disabled={submitting}>
              {submitting ? 'Saving…' : 'Save and continue'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
